import { useState } from "react";
import { Input } from "@babackapp/ui/components/input";
import { cn } from "@/utils/cn";
import type { ExtensionKeyDescriptor } from "./extension-keys";

interface ExtensionWordingFieldProps {
  descriptor: ExtensionKeyDescriptor;
  languages: string[];
  value: Record<string, string> | undefined;
  onChange: (value: Record<string, string>) => void;
  disabled?: boolean | string;
}

export function ExtensionWordingField({
  descriptor,
  languages,
  value,
  onChange,
  disabled,
}: ExtensionWordingFieldProps) {
  const [activeTab, setActiveTab] = useState(languages[0] || "en");

  const handleChange = (lang: string, text: string) => {
    const newValue = { ...value };
    if (text.trim()) {
      newValue[lang] = text;
    } else {
      delete newValue[lang];
    }
    onChange(newValue);
  };

  const currentValue = value?.[activeTab] ?? "";
  const placeholder =
    descriptor.placeholder[activeTab] || descriptor.placeholder["en"] || "";

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-medium">{descriptor.label}</label>
      <div className="flex gap-1 mb-1">
        {languages.map((lang) => {
          const hasValue = Boolean(value?.[lang]?.trim());
          return (
            <button
              key={lang}
              type="button"
              onClick={() => setActiveTab(lang)}
              className={cn(
                "px-2 py-1 text-xs rounded border transition-colors",
                activeTab === lang
                  ? "border-primary bg-primary/10 text-primary"
                  : "border-border text-muted-foreground hover:bg-accent",
                hasValue &&
                  activeTab !== lang &&
                  "border-green-500/50 text-green-600",
              )}
            >
              {lang.toUpperCase()}
            </button>
          );
        })}
      </div>
      <Input
        value={currentValue}
        onChange={(e) => handleChange(activeTab, e.target.value)}
        placeholder={placeholder}
        disabled={Boolean(disabled)}
      />
      <p className="text-xs text-muted-foreground">
        Laissez vide pour utiliser la traduction par défaut
      </p>
    </div>
  );
}
